module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8716/img/iphone-frame.png"